import './footer.scss';

function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <footer>©2019 - {currentYear} | Elisa Ridel</footer>
  )
}

export default Footer;